// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1knnm","list":"BalanceDue_list__lHIlX","listRow":"BalanceDue_listRow__3Mc9_","total":"BalanceDue_total__2dFiG"};